import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
	actions: {
		width: '100%',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
	},
}));

export default useStyles;
